import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Field, InputGroup } from 'core/form';
import { withRouter } from 'react-router-dom';
import { Button, ButtonGroupTab, ButtonGroupTabs, Card, Link, Flex, Text } from 'core/components';
import { TAB_ID_CUSTOM_USER, TAB_ID_CROSS_TENENCY_POLICY } from './utils/constants';

const { OCI_PUBLIC_KEY } = require('@kentik/ui-shared/util/oci/constants');

@withRouter
@inject('$cloudExportWizard', '$credentials')
@observer
class OciAuthenticationPanel extends Component {
  async componentDidMount() {
    const { $cloudExportWizard, form } = this.props;
    if (form) {
      $cloudExportWizard.setForm(form);
    }
  }

  handleTabChange = (tabId) => {
    const { $cloudExportWizard } = this.props;
    $cloudExportWizard.setFieldValue('properties.oci_api_access_method', tabId);
    if (tabId === TAB_ID_CROSS_TENENCY_POLICY) {
      $cloudExportWizard.setFieldValue('properties.oci_user_id', '');
    }
  };

  handleDownloadPublicKey = () => {
    const blob = new Blob([OCI_PUBLIC_KEY], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'kentik_oci_public_key.pem';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  render() {
    const { $cloudExportWizard } = this.props;

    return (
      <Flex flex={1} flexDirection="column" gap="1">
        <ButtonGroupTabs
          omitTabsWrapper
          onChange={this.handleTabChange}
          selectedTabId={$cloudExportWizard.getFieldValue('properties.oci_api_access_method')}
        >
          <ButtonGroupTab
            id={TAB_ID_CROSS_TENENCY_POLICY}
            text="Cross Tenancy Policy"
            panel={<Text small>Kentik Subscription Id will be used for all api requests.</Text>}
          />
          <ButtonGroupTab
            id={TAB_ID_CUSTOM_USER}
            title="Custom User"
            panel={
              <Card bg="backgrounds.app">
                <Flex flexDirection="column" gap={1} p={2}>
                  <Flex justifyContent="space-between">
                    <Field
                      name="properties.oci_user_id"
                      width="100%"
                      large
                      helperText={
                        <Text>
                          If you do not wish to use a Cross Tenancy Policy, you must create a User and configure it with
                          the Kentik Public Key.{' '}
                          <Link to="https://kb.kentik.com/docs/kentik-for-oci#create-an-oci-user" blank>
                            See Knowledge Base Article for details
                          </Link>
                        </Text>
                      }
                    >
                      <InputGroup />
                    </Field>
                  </Flex>

                  <Button width="250px" onClick={this.handleDownloadPublicKey}>
                    Download Public Key
                  </Button>
                </Flex>
              </Card>
            }
          />
        </ButtonGroupTabs>
      </Flex>
    );
  }
}

export default OciAuthenticationPanel;
